import $ from 'jquery';
import 'what-input';
import { Foundation, Reveal, Drilldown,DropdownMenu, MediaQuery, Keyboard,
         Box, Touch, Nest, Accordion, AccordionMenu, ResponsiveMenu, 
         ResponsiveToggle, Tabs,  onImagesLoaded, Abide, Toggler, Motion } from 'foundation-sites';

window.jQuery = $;
window.$ = $;
window.Foundation = Foundation;
Foundation.addToJquery(jQuery);

Foundation.plugin(Motion, "Motion");
Foundation.plugin(MediaQuery, "MediaQuery");
Foundation.plugin(Keyboard, "Keyboard");
Foundation.plugin(Box, "Box");
Foundation.plugin(Nest, "Nest");
Foundation.plugin(Touch, "Touch");
Foundation.plugin(Reveal, "Reveal");
Foundation.plugin(Drilldown, "Drilldown");
Foundation.plugin(DropdownMenu, "DropdownMenu");
Foundation.plugin(Accordion, "Accordion");
Foundation.plugin(ResponsiveMenu, "ResponsiveMenu");
Foundation.plugin(ResponsiveToggle, "ResponsiveToggle");
Foundation.plugin(AccordionMenu, "AccordionMenu");
Foundation.plugin(onImagesLoaded, "onImagesLoaded");
Foundation.plugin(Tabs, "Tabs");
Foundation.plugin(Abide, "Abide");
Foundation.plugin(Toggler, "Toggler");

function minLengthValidator(
  $el /* jQuery element to validate */,
  required /* is the element required according to the `[required]` attribute */,
  parent /* parent of the jQuery element `$el` */
) {
  if (!required) return true;
  return $el.val().length >= 2;
}
function minDateValidator(
    $el /* jQuery element to validate */,
    required /* is the element required according to the `[required]` attribute */,
    parent /* parent of the jQuery element `$el` */
) {
    if (!required) return true;
    var givenDate = $el.val();
    var currentDate = new Date();
    givenDate = new Date(givenDate);
    return givenDate > currentDate;
}

Foundation.Abide.defaults.validators["minDateValidator"] = minDateValidator;
Foundation.Abide.defaults.validators["minLengthValidator"] = minLengthValidator;
Foundation.Abide.defaults.patterns["zip"] = /^\d{5}(?:[-\s]\d{4})?$/;
Foundation.Abide.defaults.patterns["phone"] =
    /^(\+?[0-9]{1,3}[-. ]?)?(?!(?:\D*0)+\D*$)\(?([0-9]{3})\)?[-. ]?[0-9]{3}[-. ]?[0-9]{4}$/;
Foundation.Abide.defaults.patterns["phone-dashes"] =
    /^(\+?[0-9]{1,3}-)?(?!(?:\D*0)+\D*$)[0-9]{3}-[0-9]{3}-[0-9]{4}$/;
Foundation.Abide.defaults.patterns["dateformat"] = /^(?:(0[1-9]|1[012])[\/.](0[1-9]|[12][0-9]|3[01])[\/.](19|20)[0-9]{2})$/;
Foundation.Abide.defaults.validateOnBlur = true;
Foundation.Abide.defaults.patterns["url"] = /^((?:(https?):\/\/)(?:[^\s()<>]+|\((?:[^\s()<>]+|(?:\([^\s()<>]+\)))*\))+(?:\((?:[^\s()<>]+|(?:\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:\'".,<>?\xab\xbb\u201c\u201d\u2018\u2019]))/;
Foundation.Abide.defaults.validators['greater_than'] = function ($el, required, parent) {
    if (!required) return true;

    var otherVal = $('#' + $el.attr('data-greater-than')).val();
    var thisVal = $el.val();

    return thisVal > otherVal;
};
Foundation.Abide.defaults.validators['greater_than_eq'] = function ($el, required, parent) {
    if (!required) return true;

    var otherVal = $('#' + $el.attr('data-greater-than')).val();
    var thisVal = $el.val();

    return thisVal >= otherVal;
};
Foundation.Abide.defaults.validators['endTimeValidator'] = function ($el, required, parent) {
    if (!required) return true;

    var startTimeId = $el.data('start-time-id');
    var $startTimeInput = $('#' + startTimeId);

    if (!startTimeId || $startTimeInput.length === 0) {
        console.error('Invalid or missing ID provided for endTimeValidator.');
        return false;
    }

    // time inputs have values like "13:05", not the visible "1:05 PM"
    let startStr = $startTimeInput.val();
    let endStr = $el.val();
    let timeOnlyRegex = /^(0?[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;
    let timeOnlyStart = timeOnlyRegex.test(startStr);
    let timeOnlyEnd = timeOnlyRegex.test(endStr);

    if (timeOnlyStart != timeOnlyEnd) {
        console.error('endTimeValidator cannot compare start and end times in different formats');
        return false;
    }

    let startDate, endDate;
    if (timeOnlyStart) {
        var start = startStr.split(':');
        var end = endStr.split(':');
        startDate = new Date();
        startDate.setHours(start[0], start[1]);

        endDate = new Date();
        endDate.setHours(end[0], end[1]);
    }
    else {
        var startMS = Date.parse(startStr);
        var endMS = Date.parse(endStr);
        if (isNaN(startMS)) {
            console.error('endTimeValidator cannot parse start time');
            return false;
        }
        if (isNaN(endMS)) {
            console.error('endTimeValidator cannot parse end time');
            return false;
        }
        startDate = new Date(startMS);
        endDate = new Date(endMS);
    }

    return endDate > startDate;
};

Foundation.Abide.defaults.validators['buyerEmailNotUsed'] = function ($el, required, parent) {
    if ($el.val() == '')
        return true;

    let emailExists;
    $.ajax({
        url: '/BuyerEmailExists?emailAddress=' + $el.val(),
        async: false,
        success: function (resp) {
            emailExists = resp;
        },
        error: function (jqXHR) {
            console.log('Error checking if submitted email address is in use:');
            console.log(jqXHR);
            emailExists = true;
        }
    });
    return !emailExists;
};

jQuery(document).foundation();
